import * as Yup from "yup";

export const loginSchema = Yup.object().shape({
  username: Yup.string().required("Username field cannot be empty"),
  password: Yup.string().required("Password field cannot be empty"),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email field cannot be empty"),
});

export const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)/,
      "Password must contain at least one number and one special character"
    )
    .required("Password is required."),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  code: Yup.string().min(6, "Code is too short").required("Code is required."),
});

export const renewPasswordWithCurrentPasswordSchema = Yup.object().shape({
  current_password: Yup.string().required("Current Password is required."),
  password: Yup.string()
    .required("Password is required.")
    .min(8, "Password must be at least 8 characters long.")
    .matches(/^(?=.*[a-zA-Z])/, "Password cannot be digits only."),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password is required."),
});
